module.exports = __webpack_public_path__ + "static/media/banescard.6ce23eb2.png";